import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

let isValidInputs = true;
const ContactUSPopup = (props) => {
    let isValidInputs = true;
    const [fullname, setFullname] = useState("");
    const [fullnameErr, setFullnameErr] = useState(false);
    const [email, setEmail] = useState("");
    const [emailErr, setEmailErr] = useState(false);
    const [subject, setSubject] = useState("");
    const [subjectErr, setSubjectErr] = useState(false);
    const [message, setMessage] = useState("");
    const [messageErr, setMessageErr] = useState(false);
    const [querySent, setQuerySent] = useState(false);
    const [querySentText, setQuerySentText] = useState(
        "Thanks for reaching out! We will look over your message and get back to you soon"
    );
    useEffect(() => {}, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        validateInputs();
        if (isValidInputs) {
            var xhr = new XMLHttpRequest();
            var url =
                "https://api.hsforms.com/submissions/v3/integration/submit/25310090/c16bdfec-a21e-4bff-9717-691200c2da14";
            var data = {
                submittedAt: Date.now(),
                fields: [
                    {
                        name: "firstname",
                        value: fullname,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "company",
                        value: subject,
                    },
                    {
                        name: "message",
                        value: message,
                    },
                    {
                        name: "source_type",
                        value: "Contact us",
                    },
                ],
            };
            var final_data = JSON.stringify(data);
            xhr.open("POST", url);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    setEmail("");
                    setFullname("");
                    setSubject("");
                    setMessage("");
                    setQuerySent(true);
                    setTimeout(() => {
                        setQuerySent(false);
                    }, 6000);
                    // Returns a 200 response if the submission is successful.
                } else if (xhr.readyState == 4 && xhr.status == 400) {
                    setQuerySentText(xhr.responseText);
                } else if (xhr.readyState == 4 && xhr.status == 403) {
                    setQuerySentText(xhr.responseText);
                }
            };
            xhr.send(final_data);
        }
    };
    const validateInputs = () => {

        const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let emailId = email;
        let isInvalidEmail =
            emailId.length < 2 || !emailRegEx.test(String(emailId).toLowerCase());
        let isInvalidName = fullname.length < 3;
        let isInvalidSubject = subject.length < 1;
        let isInvalidMessage = message.length < 3;

        if (isInvalidEmail) {
            setEmailErr(true);
        }
        if (isInvalidName) {
            setFullnameErr(true);
        }
        if (isInvalidSubject) {
            setSubjectErr(true);
        }
        if (isInvalidMessage) {
            setMessageErr(true);
        }
        isValidInputs =
            !isInvalidEmail &&
            !isInvalidName &&
            !isInvalidSubject &&
            !isInvalidMessage;
    };

    return (
        <div className={"contact-form"}>
                <div className={"form"}>
                    <h4>
                        Provide Details & Expect a <span className={"text-gradient"}> Response Within 24hrs </span> from Our Experts</h4>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className={"d-flex"}>
                            <div className={"input-wrapper"}>
                                <label>Full Name</label>
                                <br />
                                <input
                                    type={"text"}
                                    value={fullname}
                                    placeholder={"Full name"}
                                    className={`${
                                        fullnameErr ? "is-error contact-input" : "contact-input"
                                    }`}
                                    onChange={(e) => {
                                        const value = e.target && e.target.value;
                                        setFullname(value);
                                    }}
                                    onKeyUp={(e) => {
                                        if (fullname.length > 0) {
                                            setFullnameErr(false);
                                        }
                                    }}
                                />
                                <h6
                                    className={`form-input-validation ${
                                        fullnameErr ? "error" : ""
                                    }`}
                                >
                                    Full name is required
                                </h6>
                            </div>

                            <div className={"input-wrapper"}>
                                <label>Business Email</label>
                                <br />
                                <input
                                    type={"text"}
                                    value={email}
                                    placeholder={"Enter email"}
                                    className={`${
                                        emailErr ? "is-error contact-input" : "contact-input"
                                    }`}
                                    onChange={(e) => {
                                        const value = e.target && e.target.value;
                                        setEmail(value);
                                    }}
                                    onKeyUp={(e) => {
                                        if (email.length > 0) {
                                            setEmailErr(false);
                                        }
                                    }}
                                />
                                <h6
                                    className={`form-input-validation ${emailErr ? "error" : ""}`}
                                >
                                    {email.length < 1
                                        ? "Email is required"
                                        : "Please enter your business email"}
                                </h6>
                            </div>
                        </div>

                        <div className={"input-wrapper"}>
                            <label>Company Name</label>
                            <br />
                            <input
                                type={"text"}
                                value={subject}
                                placeholder={"Enter company name here"}
                                className={`${
                                    subjectErr ? "is-error contact-input" : "contact-input"
                                }`}
                                onChange={(e) => {
                                    const value = e.target && e.target.value;
                                    setSubject(value);
                                }}
                                onKeyUp={(e) => {
                                    if (subject.length > 0) {
                                        setSubjectErr(false);
                                    }
                                }}
                            />
                            <h6
                                className={`form-input-validation ${subjectErr ? "error" : ""}`}
                            >
                                Company name is required
                            </h6>
                        </div>

                        <div className={"input-wrapper"}>
                            <div className={""}>
                                <label>How can we help?</label>
                                <br />
                                <textarea
                                    value={message}
                                    placeholder={"Tell us more about your goals with Middleware"}
                                    className={`${
                                        messageErr ? "is-error contact-input" : "contact-input"
                                    }`}
                                    onChange={(e) => {
                                        const value = e.target && e.target.value;
                                        setMessage(value);
                                    }}
                                    onKeyUp={(e) => {
                                        if (message.length > 0) {
                                            setMessageErr(false);
                                        }
                                    }}
                                />
                                <h6
                                    className={`form-input-validation ${
                                        messageErr ? "error" : ""
                                    }`}
                                >
                                    Minimum 3 characters required
                                </h6>
                            </div>
                        </div>

                        <button type={"submit"} className={"primary arrow"}>
                            Apply Now
                        </button>
                        {querySent && (
                            <h6
                                className={`form-input-validation ${
                                    querySent ? "success" : "error"
                                }`}
                            >
                                {querySentText}
                            </h6>
                        )}
                    </form>
                </div>
        </div>
    );
};
ContactUSPopup.propTypes = {
    title: PropTypes.string,
    location: PropTypes.string,
};
export default ContactUSPopup;